import { curry, path } from 'ramda'

/**
 * Gets the value of an attribute.
 *
 * @type {Function}
 * @param {String} name
 * @param {Object} entity
 * @return {*}
 */
const getAttr = curry((name, entity) => path(['attributes', name], entity))

export default getAttr
